module.exports = __webpack_public_path__ + "static/media/cake.fb604dd6.png";